<h1>{{ 'Finalize mesh settings' | translate }}</h1>
<p>
  {{ 'Finalizing will lock the following settings forever:' | translate }}
</p>
<ul>
  <li>{{ 'Scaling' | translate }}</li>
  <li>{{ 'Rotation' | translate }}</li>
</ul>
<p>
  {{ 'Are you satisfied with how your object is displayed?' | translate }}
</p>
<k-button-row gap="4">
  <k-button type="outlined-secondary" (click)="close(false)" full-width>{{
    'No, cancel and adjust' | translate
  }}</k-button>
  <k-button type="solid-primary" (click)="close(true)" full-width>{{ 'Yes, finalize' | translate }}</k-button>
</k-button-row>
